export default Object.freeze({
  black: '#000000',
  almostBlack: '#29292c',
  white: '#fff',
  suvaGrey: '#8b8685',
  norticBlue: '#303ab2',
  pigPink: '#fdd7e4',
  floralWhite: '#fffaf0',
  lavender: '#e6e6fa',
  red: '#ff0000',
  crimson: '#ae0500',
  atlantis: '#9cd03b',
  eden: '#266255',
  internationalOrange: '#ffc527',
  blueViolet: '#8a2be2',
  portica: '#f0d555',
  prussianBlue: '#003366',
  spindle: '#b3c4d8',
  darkTangerine: '#ffa812',
  deepSkyBlue: '#00bfff',
  sunsetOrange: '#fa4f4f',
  forestGreen: '#28a745',
  wildWatermelon: '#fd5b78',
  royalBlue: '#4169e1',
  mountainMeadow: '#1ab385',
});
